import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererActions from "@/components/frequency/list/cell-renderer/CellRendererActions.vue";

export const frequencyListMixin = {
	name: "FrequencyList",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showPopup: false,
				};
			},
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererActions,
	},
	data() {
		return {
			searchQuery: [],
			currentPageLocal: 1,
			quantityElementPage: 10,
			searchField: "Name",
			isExactly: false,
			gridApi: null,
			gridOptions: {},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererActions,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
		};
	},
	watch: {
		currentPageLocal(page) {
			this.getFrequencies(page);
		},
		quantityElementPage() {
			this.getFrequencies(1);
		},
	},
	async mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactly = matchFilter.filter_exact_frequency;
		} else {
			this.isExactly = this.$store.state.moduleMatchFilter.filter_exact_frequency;
		}
		this.getFrequencies(1);
	},
	computed: {
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let filterHead = this.customConfig.filterHead !== undefined ? this.customConfig.filterHead : true;
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 250,
					filter: filterHead,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
				},
				{
					headerName: this.$t("Routing.Table.Name"),
					field: "name",
					filter: filterHead,
					width: 450,
				},
				{
					headerName: this.$t("TimeWindow.Duration"),
					field: "duration",
					filter: filterHead,
					width: 250,
				},
				{
					headerName: this.$t("Description"),
					field: "description",
					filter: filterHead,
					width: 750,
				},
				{
					headerName: this.$t("BreakTable.Action"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}

			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`${this.searchField}`);
		},
		frequenciesData() {
			return this.$store.state.frequency.frequencyList;
		},
		getCheckedFrequencies() {
			return this.$store.state.frequency.checkedFrequencies;
		},
	},
	methods: {
		getFrequencies(page) {
			this.onBtShowLoading();
			const payload = {
				page,
				quantity: this.quantityElementPage,
				match_filter: !this.isExactly,
				sort: "desc",
				order_by: ["id"],
			};
			this.$store
				.dispatch("frequency/frequencyFilter", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		search() {
			const searchQueryList = this.searchQuery.map(({value}) => {
				if (this.searchField === "Id") return parseInt(value);
				return value;
			});
			const dataPage = {
				id: this.searchField === "Id" ? searchQueryList : [],
				name: this.searchField === "Name" ? searchQueryList : [],
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("frequency/frequencyFilter", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		searchAssignedFrequencies(searchField, searchQuery, page) {
			const searchQueryList =
				searchField === "Id"
					? searchQuery.map(({value}) => parseInt(value))
					: searchQuery.map(({value}) => value);
			const dataPage = {
				id: searchField === "Id" ? searchQueryList : [],
				name: searchField === "Name" ? searchQueryList : [],
				match_filter: !this.isExactly,
				page: page ? page : currentPageLocal,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("frequency/frequencyFilter", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		refresh() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.$store.commit("frequency/REMOVE_ALL_FREQUENCY_CHECKED");
			this.getFrequencies(1);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		rowSelected(event) {
			const isSelected = event.node.isSelected();
			if (isSelected) {
				this.$store.commit("frequency/ADD_FREQUENCY_CHECKED", event.data);
			} else {
				this.$store.commit("frequency/REMOVE_FREQUENCY_CHECKED", event.data);
			}
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("Preferences.FilterSearchExactText")}`,
					accept: () => {
						this.isExactly = val;
						this.updateMatchFilter();
					},
					cancel: () => {
						this.isExactly = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			} else {
				this.isExactly = val;
				this.updateMatchFilter();
			}
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_frequency"] = this.isExactly;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
		setDefaultSelectedRow() {
			const relatedIds = this.getCheckedFrequencies;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
	},
	beforeDestroy() {
		this.$store.commit("frequency/REMOVE_ALL_FREQUENCY_CHECKED");
	},
};
